import { useTranslate } from '@tolgee/react';
import { BaseSysMsgProps } from './types';
import { SystemMessage } from 'components/Dialogue';
import dayjs from 'lib/dayjs';
import { toNumber } from 'lodash-es';
import { memo } from 'react';

export const SysAutoMarkSalesStatusMsg = memo((props: BaseSysMsgProps) => {
  const { raw } = props;
  const { t } = useTranslate();

  if (raw?.sysAutoMarkSalesStatusContent) {
    const { timestamp, salesStatus } = raw.sysAutoMarkSalesStatusContent;
    const salesStatusMap: Record<string, string> = {
      BEFORE_SALES_STATUS: t('domain.salesStage.preSalesBuyer'),
      DURING_SALES_STATUS: t('domain.salesStage.inSalesBuyer'),
      AFTER_SALES_STATUS: t('domain.salesStage.afterSalesBuyer'),
    };

    return (
      <SystemMessage>
        {t('scene.chatWorkspace.messageThread.systemMessage.salesStatusChanged', {
          time: dayjs(toNumber(timestamp)).format('MM-DD HH:mm:ss'),
          who: t('domain.returnRefund.cancelType.system'),
          buyerWho: salesStatusMap[salesStatus],
        })}
      </SystemMessage>
    );
  }

  return null;
});
